import { render } from "./ShowcaseView.vue?vue&type=template&id=367aae17&ts=true"
import script from "./ShowcaseView.vue?vue&type=script&lang=ts"
export * from "./ShowcaseView.vue?vue&type=script&lang=ts"

import "@/assets/styles/showcase/layouts/_show-case.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__